<template>
  <div class="cert-carousel" v-if="!showError">
    <div class="cert-left" @click="back()">
      <micon icon="chevron_left"/>
    </div>
    <div class="cert-right" @click="next()">
      <micon icon="chevron_right"/>
    </div>
    <div v-if="alertList!=null" class="cert-carousel-content row mx-0" :class="fade">
      <div v-for="(item,index) in activeList" :key="index" class="col-12 col-xl-6 px-0 mx-auto mx-xl-0">
        <cert-alert-card :id="item.uid" :title="item.title" :date="item.datetime?.human"
                         :image="`${baseUrl}proxy/${horusBase64.stringToBase64URLSafe(item.images?.[0]?.url)}`" type="advisories"/>
      </div>
    </div>
    <cert-progress-indicator v-if="alertList==null"/>
  </div>
  <cert-color-box v-if="showError" title="Could not load alerts" icon="error_outline"/>
</template>

<script>

import CertColorBox from "@/views/cert/components/CertColorBox";
import CertProgressIndicator from "@/views/cert/components/CertProgressIndicator";
import CertAlertCard from './CertAlertCard.vue';
import api from '../../../api.js';
import horusBase64 from "@/components/horusBase64";

export default {
  name: "CertAlertCaroussel",
  computed: {
    horusBase64() {
      return horusBase64
    }
  },
  components: {
    CertAlertCard,
    CertColorBox,
    CertProgressIndicator,
  },
  data() {
    return {
      fade: "",
      interval: null,
      activeCount: 2,
      activeIndex: 0,
      activeList: [],
      alertList: null,
      showError: false,
      baseUrlCyber: process.env.VUE_APP_BASE_URL_CYBER,
      baseUrl: process.env.VUE_APP_BASE_URL,
    }
  },
  created() {
    this.loadAlerts();
  },
  methods: {
    loadAlerts() {
      api
          .get(`${process.env.VUE_APP_BASE_URL}proxy/${horusBase64.stringToBase64URLSafe("api/advisories")}`)
          .then((response) => {
            this.alertList = response.data?.items;
            this.setElementsNext();
            this.showError = false;
          })
          .catch((error) => {
            error;
            this.showError = true;
          });
    },
    next() {
      this.fade = "fade-out-left";
      setTimeout(() => {
        this.fade = "set-right"
      }, 500);

      setTimeout(() => {
        this.setElementsNext();
        this.fade = "";
      }, 600);
    },
    back() {
      this.fade = "fade-out-right";
      setTimeout(() => {
        this.fade = "set-left"
      }, 500);

      setTimeout(() => {
        this.setElementsNext();
        this.fade = "";
      }, 600);
    },
    updateElements() {
      this.activeList = [];
      for (let i = this.activeIndex; i < this.activeIndex + this.activeCount; i++) {
        this.activeList.push(this.alertList[i % this.alertList.length])
      }
      this.startInterval();
    },
    setElementsNext() {
      this.updateElements();
      this.activeIndex += this.activeCount;
    },
    startInterval() {
      if (this.interval != null)
        clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.next();
      }, 8000);
    }
  },

}
</script>

<style scoped>

</style>